export default __webpack_public_path__ + "static/media/218.b672f78c.jpg";